import PropTypes from 'prop-types'
import FormInput from './FormInput';

const SettingBkImages = ( { DeviceSetting, onSettingChange } ) => {
    
    const setSetting = (changedSettings) => {
        var tempSettings = [{...DeviceSetting}];
        
        changedSettings.forEach(({setting, value}) => {
            try {
                // Change the setting
                tempSettings[0][setting] = value;
            } catch (error) {
                console.log('ERROR: getSetting', setting, DeviceSetting, value, error);
            }
        });
        // call the Change State
        onSettingChange( tempSettings );
    }

    const imageList = [];
    for (let index = 1; index <= 20; index++) {
        imageList.push(index);
    }
    
    const onBkImageToggle = (e, index) => {
        let retValue = '';
        let bkArray = DeviceSetting['background-images'].split(',');

        // Remove the last empty element
        bkArray = bkArray.filter(e => (e!==''));

        // Add or remove the item (index)
        bkArray = bkArray.filter(e => (`${e}` !== `${index}`));
        e && (bkArray.push(index));

        // Update the Setting Change
        bkArray.sort((a, b) => {
                        return a - b;
                    });
        retValue = bkArray.toString() + ',';    // Adding trailing ,
        let settingArr = [{setting: 'background-images', value: `${retValue}`}];
        setSetting( settingArr );
    }

    return (
        <>
            {imageList.length === 0 ? (
                <div className="centered"><span className="spinner" /></div>
            ) : (
                <div className="thumbs">
                    {imageList.map((i) => {
                        const chosen = DeviceSetting['background-images'].includes(`${i},`);
                        return (
                            <button
                                type="button"
                                key={`bg-${DeviceSetting.device_id}-${i}`}
                                className={'thumb' + (chosen ? ' thumb--on' : '')}
                                aria-pressed={chosen}
                                aria-label={`Background picture ${i}`}
                                onClick={() => onBkImageToggle(!chosen, i)}
                            >
                                <img
                                    alt=""
                                    loading="lazy"
                                    src={import.meta.env.REACT_APP_IMAGES_URL + '/' + i + '.jpg'} />
                            </button>
                        );
                    })}
                </div>
            )}
        </>
    );
}

SettingBkImages.propTypes = {
    DeviceSetting: PropTypes.object.isRequired,
    onSettingChange: PropTypes.func.isRequired,
}

export default SettingBkImages

